import autosize from 'autosize';

export default function () {
    // Do yo JAHVAHSCRIPT here.
    let windowWidth = $(window).width() + 15;
    $(window).on('resize', () => {
        windowWidth = $(window).width() + 15;

        if (windowWidth >= 1007) {
            $('nav.nav').removeClass('mobile-menu-open');
            $('header').removeClass('active-header');
            $('.mobile-nav-trigger').removeClass('active');
        }
    });

    // ==> Mobile nav controller
    $('.mobile-nav-trigger').on('click', function () {
        $(this).toggleClass('active');
        $('nav.nav').toggleClass('mobile-menu-open');
        $('header').toggleClass('active-header');
        $('.nav-categories').removeClass('show-categories');
        $('.nav-category-title').removeClass('show-sub-categories')
        $('minus').removeClass('minus')
        $('.bottom-info.my-account').removeClass('open');
        $('.sigin-menu-card').removeClass('active');

        if (windowWidth >= 768) {
            $('.my-account-trigger').removeClass('triggered');
        }
    });
    autosize($('textarea'));


    // ==> Adds tabindex to nav menu a tags for a11y purposes
    $('.nav-categories a').attr('tabindex', 0);
    $('.my-account-trigger').on('click', () => {
        $(this).toggleClass('active');
        $('.sigin-menu-card').toggleClass('active');
        $('.bottom-info').toggleClass('open');

        if (windowWidth >= 768) {
            $('nav.nav').removeClass('mobile-menu-open');
            $('header').removeClass('active-header');
            $('.my-account-trigger').toggleClass('triggered');
            $('.mobile-nav-trigger').removeClass('active');
        }
    });
    $('.close-button').on('click', () => {
        $('.signin-menu-overlay').removeClass('active')
        $('.signin-overlay-trigger').removeClass('active')
    });
    $('.back-arrow').on('click', () => {
        $('.bottom-info.my-account').removeClass('open');
        $('.sigin-menu-card').removeClass('active');
    });
    $('.signin-overlay-trigger').on('click', () => {
        if ($('.signin-overlay-trigger').hasClass('active')) {
            $('.signin-overlay-trigger.active').removeClass('active');
            $('.signin-menu-overlay.active').removeClass('active');
        } else {
            $('.signin-menu-overlay').addClass('active');
            $('.signin-overlay-trigger').addClass('active');

            if(!$('.nav').hasClass('mobile-menu-open') && windowWidth < 992) {
                $('.nav').addClass('mobile-menu-open');
                $('.mobile-nav-trigger').addClass('active');
                $('.header').addClass('active-header');
            }
        }
    });
    $(document).ready(() => {
        $('#menu-footer').addClass('container');
    });

    $('.dropdown-submenu-wrapper').on('mouseover', function() {
        $(this).siblings().addClass('active-dropdown');
    });
    
    $('.dropdown-submenu-wrapper').on('mouseout', function() {
        $(this).siblings().removeClass('active-dropdown');
    });

    $('.is-dropdown').on('click', function() {
        if(!$(this).hasClass('dropped-dropdown')) {
            $('.is-dropdown').removeClass('dropped-dropdown');
            $(this).toggleClass('dropped-dropdown');
        } else if($(this).hasClass('dropped-dropdown')){
            $(this).removeClass('dropped-dropdown');
        } 
    });
    

    // ==> FAQ dropdown controller
    $('.faq-card-header').on('click', function () {
        if ($(this).siblings('.faq-collapse').is(':visible')) {
            $('.faq-card .faq-collapse').slideUp();
            $(this).children('.faq-button').removeClass('collapsed');
        } else {
            $('.faq-card .faq-button').removeClass('collapsed');
            $('.faq-card .faq-collapse').slideUp();
            $(this).children('.faq-button').toggleClass('collapsed');
            $(this).siblings('.faq-collapse').slideToggle();
        }
    });

    // ==> Accordion
    let isAnimating = false;

    $('.single-accord .plus').on('click', function() {
        const parent = $(this).parent().parent();

        if ($(this).hasClass('rotate-icon')) {
            $(this).removeClass('rotate-icon');
            parent.siblings().removeClass('current').slideUp();
        } else {
            $curAccord.find('.single-accord .display-status').slideUp().removeClass('current');
            $curAccord.find('.single-accord .title .plus').removeClass('rotate-icon');

            $(this).addClass('rotate-icon');
            parent.siblings().addClass('current').slideDown();
        }
    });

    // END
    $('.single-accord .title').on('click', function (e) {
        // limiting scope of interaction to just one carousel when more than one carousels are on the page.
        const $curAccord = $(this).parent().parent();
        if (!isAnimating) {
            isAnimating = true;
            if ($(this).next().hasClass('current')) {
                $curAccord.find('.single-accord .title .plus').removeClass('rotate-icon');
                // $curAccord.find('.single-accord .accordion').removeClass('change-color');
                $(this).next().removeClass('current').slideUp(() => {
                    isAnimating = false;
                });
            } else {
                $curAccord.find('.single-accord .display-status').slideUp().removeClass('current');
                $curAccord.find('.single-accord .title .plus').removeClass('rotate-icon');
                // $curAccord.find('.single-accord .accordion').removeClass('change-color');
                $(this).next().addClass('current').slideToggle(() => {
                    isAnimating = false;
                });
                $(this).find('span').addClass('rotate-icon');
                // $(this).find('.accordion').addClass('change-color');
            }
        }
    });

    $('.display-status.accordion-content').addClass('current').slideToggle();
    $('.single-accord .plus').addClass('rotate-icon');

    // ==> Tabs
    const tabs = document.querySelectorAll('[data-tab-target]');
    const tabContents = document.querySelectorAll('[data-tab-content]');

    if (tabs.length && tabContents.length) {
        tabs.forEach(tab => {
            // Add ".active" to first tab
            tabs[0].classList.add('active');
            tabContents[0].classList.add('active');
            // The magic
            tab.addEventListener('click', () => {
                const target = document.querySelector(tab.dataset.tabTarget);
                tabContents.forEach(tabContent => {
                    tabContent.classList.remove('active');
                });
                tabs.forEach(tab => {
                    tab.classList.remove('active');
                });
                tab.classList.add('active');
                target.classList.add('active');
            });
        });
    }

    // ==> Domain search dropdown
    $('.domain-search-dropdown').click(function () {
        $(this).attr('tabindex', 1).focus();
        $(this).toggleClass('active');
        $(this).find('.domain-search-dropdown-menu').slideToggle(300);
    });
    $('.domain-search-dropdown').focusout(function () {
        $(this).removeClass('active');
        $(this).find('.domain-search-dropdown-menu').slideUp(300);
    });
    $('.domain-search-dropdown .domain-search-dropdown-menu li').click(function () {
        $(this).parents('.domain-search-dropdown').find('span').text($(this).text());
        $(this).parents('.domain-search-dropdown').find('input').attr('value', $(this).attr('value'));
        $(this).parents('.domain-search-input-container').find('input.hidden-tld').attr('value', $(this).attr('value'));
    });

    // ==> Incremental counter
    $(document).ready(() => {
        $('.minus').click(function () {
            const $input = $(this).parent().find('input');
            let count = parseInt($input.val()) - 1;
            count = count < 1 ? 1 : count;
            $input.val(count);
            $input.change();
            return false;
        });
        $('.plus').click(function () {
            const $input = $(this).parent().find('input');
            $input.val(parseInt($input.val()) + 1);
            $input.change();
            return false;
        });
        // Restrict max quantity
        $('input[type="number"]').on('change input keyup paste', function () {
            if (this.max) this.value = Math.min(parseInt(this.max), parseInt(this.value) || 0);
        });
    });

    // => Sticky Reactive Sidebar Pattern
    $(document).ready(() => {
        $('.open-close-sticky').on('click', () => {
            $('.reactive-sticky-sidebar').toggleClass('active');
        });

        $('.reactive-sticky-sidebar a').on('click', () => {
            $('.reactive-sticky-sidebar').removeClass('active');
        });

        $(window).on('scroll', () => {
            const scrollDistance = $(window).scrollTop();

            $('.reactive-sticky-sidebar p').each(function() {
                const sectionId = $(this).find('a').attr('href');
                const sectionOffset = $(sectionId).offset().top - 80;
                if (sectionOffset <= scrollDistance) {
                    $('.reactive-sticky-sidebar p a.active').removeClass('active');
                    $(this).find('a').addClass('active');
                }
            });
        });

        $('.reactive-sticky-sidebar .wp-block-button a').on('click', () => {
            const firstLink = $('.reactive-sticky-sidebar p:first-child a');
            const currentActiveLink = $('.reactive-sticky-sidebar a.active');
            currentActiveLink.removeClass('active');

            firstLink.addClass('active');
        });
    });

    // => Carousel Block
    $(document).ready(() => {
        let currentCard = 0;
        const cardWidth = $('.carousel-card').outerWidth(true);
        const totalCards = $('.carousel-card').length;
        let shownCards;
        let mobile;

        // Check Window Width to change the amount of shown cards for mobile, taking into consideration window resize
        const windowWidth = $(window).width();

        if (windowWidth <= 767) {
            shownCards = 1;
            mobile = true;
        } else if (windowWidth > 767) {
            shownCards = 2;
        }

        // Function to slide carousel from left to right and right to left
        function updateCarousel() {
            $('.carousel-wrapper').css('transform', `translateX(-${(mobile) ? (cardWidth + 24) * currentCard : cardWidth * currentCard}px)`);
        }

        // Right Arrow Functionality
        $('.right-arrow-wrapper').on('click', () => {
            if (currentCard < totalCards - shownCards) {
                currentCard++;
                updateCarousel();
            }

            if (currentCard >= 1) {
                $('.left-arrow-wrapper').removeClass('disabled').attr('disabled', false);
            }

            if (currentCard === totalCards - shownCards) {
                $('.right-arrow-wrapper').addClass('disabled').attr('disabled', true);
            }

            updatePagination();
        });

        // Left Arrow Functionality
        $('.left-arrow-wrapper').on('click', () => {
            if (currentCard > 0) {
                currentCard--;
                updateCarousel();
            }

            if (currentCard == 0) {
                $('.left-arrow-wrapper').addClass('disabled').attr('disabled', true);
            }

            if (currentCard >= 0) {
                $('.right-arrow-wrapper').removeClass('disabled').attr('disabled', false);
            }

            updatePagination();
        });

        if (totalCards <= 2 && !mobile) {
            $('.left-arrow-wrapper').hide();
            $('.right-arrow-wrapper').hide();
        }

        // Pagination Dots Code
        const paginationWrapper = $('.pagination-dots-wrapper');
        const totalDots = (mobile) ? totalCards : totalCards - 1;

        if (totalCards > 2) {
            for (let i = 0; i < totalDots; i++) {
                paginationWrapper.append('<div class="pagination-dot"></div>');

                if (i == currentCard) {
                    $('.pagination-dot').toggleClass('active');
                }
            }
        }

        function updatePagination() {
            $('.pagination-dot').removeClass('active');

            paginationWrapper.children().eq(currentCard).toggleClass('active');
        }
    });
 
    // => Review Block
    $(document).ready(() => {
        const cards = $('.author-cards-wrapper').children();
        const cardWrapper = $('.review-cards-wrapper').children();
        const intialActiveCard = $(cardWrapper[0]).children()[1];

        $(cards[0]).addClass('active');
        $(cardWrapper[0]).addClass('active');
        $(intialActiveCard).addClass('active');

        $('.author-card-wrapper').on('click', function() {
            let previousCardIndex = $('.author-card-wrapper.active').data();
            $('.review-card-wrapper.active').removeClass('active');
            $('.author-card-wrapper.active').removeClass('active');
            $('.cards-mobile-wrapper.active').removeClass('active');

            $(this).toggleClass('active');
            let active_card = $(this).data('index');
            $('.cards-mobile-wrapper[data-index="' + active_card + '"]').toggleClass('active');
            $('.review-card-wrapper[data-index="' + active_card + '"]').toggleClass('active');
        })
    });
}
